// extracted by mini-css-extract-plugin
export default {"BlockTemplateFormRoot":"BlockTemplateFormRoot---8AMVG","BlockTemplateFormContent":"BlockTemplateFormContent---AKjOx"};